/**
 * Business Terms Section - Sections 4-7: Content, Privacy, Payments, Third-Party Services
 */

import React from 'react';

export const BusinessTermsSection: React.FC = () => (
  <>
    <section>
      <h2 className="text-xl font-semibold mb-3">4. Content Ownership</h2>
      <div className="space-y-2 text-gray-600">
        <p><strong>Your Content:</strong> You retain ownership of recipes and content you create. 
        By using the Service, you grant us a license to store, display, and share your content as 
        necessary to provide the Service.</p>
        
        <p><strong>Our Content:</strong> The Service, including its design, features, and functionality, 
        is owned by DinnerBrain and is protected by copyright and other intellectual property laws.</p>
      </div>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">5. Privacy and Data Protection</h2>
      <p className="text-gray-600">
        Your use of our Service is also governed by our Privacy Policy. Please review our Privacy Policy 
        to understand how we collect, use, and protect your information.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">6. Subscription and Payments</h2>
      <div className="space-y-2 text-gray-600">
        <p>If you choose to subscribe to premium features:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Billing is handled through secure payment processors</li>
          <li>Subscriptions auto-renew unless cancelled</li>
          <li>You can cancel anytime through your account settings</li>
          <li>Refunds are provided according to our refund policy</li>
        </ul>
      </div>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">7. Third-Party Services</h2>
      <p className="text-gray-600">
        Our Service may contain links to third-party websites or services. We are not responsible for 
        the content, privacy policies, or practices of any third-party services.
      </p>
    </section>
  </>
);